import Header from "../components/Header";
import {useCustomerDataContext, ViewMode} from "../context/CustomerDataContext";
import Survey from "../components/Survey";
import Result from "../components/Result";
import {useEffect} from "react";
import {useAppDispatch} from "../../../hooks/reduxHooks";
import {setInitialState} from "../../../slices/CustomerDataSlice";
import Start from "../components/Start";

export default function CustomerDataCore() {
    const {viewMode, setViewMode} = useCustomerDataContext();
    const dispatch = useAppDispatch();

    useEffect(() => {
        setViewMode(ViewMode.Start);
        dispatch(setInitialState);
    }, [])

    return (
        <>
            <Header/>

            {
                viewMode === ViewMode.Start && <Start/>
            }

            {
                viewMode === ViewMode.Survey && <Survey/>
            }

            {
                viewMode === ViewMode.Result && <Result/>
            }
        </>
    )
}
